'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.set = exports.SET_CLEAR = exports.SET_REMOVE = exports.SET_ADD = undefined;

var _atpPointfree = require('atp-pointfree');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//Action type definitions
var SET_ADD = exports.SET_ADD = 'basic/set/add';
var SET_REMOVE = exports.SET_REMOVE = 'basic/set/remove';
var SET_CLEAR = exports.SET_CLEAR = 'basic/set/clear';

var emptySet = new Set();

//Action creators and selectors
var set = exports.set = {
    add: function add(name, value) {
        return { type: SET_ADD, name: name, value: value };
    },
    remove: function remove(name, value) {
        return { type: SET_REMOVE, name: name, value: value };
    },
    clear: function clear(name) {
        return { type: SET_CLEAR, name: name };
    },
    values: function values(getState, name) {
        return getState().basic.set[name] || emptySet;
    }
};

//Reducer
//TODO:  Something broken here if something is already in the set

exports.default = function () {
    var _switchOn;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return (0, _atpPointfree.switchOn)(action.type, (_switchOn = {}, _defineProperty(_switchOn, SET_ADD, function () {
        return (0, _atpPointfree.merge)(state, _defineProperty({}, action.name, new Set(state[action.name] ? [].concat(_toConsumableArray(state[action.name].values())) : []).add(action.value)));
    }), _defineProperty(_switchOn, SET_REMOVE, function () {
        return (0, _atpPointfree.merge)(state, _defineProperty({}, action.name, function () {
            var newSet = state[action.name] ? new Set([].concat(_toConsumableArray(state[action.name].values()))) : emptySet;
            newSet.delete(action.value);
            return newSet;
        }()));
    }), _defineProperty(_switchOn, SET_CLEAR, function () {
        return (0, _atpPointfree.remove)(action.name)(state);
    }), _defineProperty(_switchOn, 'default', function _default() {
        return state;
    }), _switchOn));
};